export class ConfigMenuNames {
    static SEND_TO_SCUD = 'send_to_scud'
    static SEND_TO_SOLVO = 'send_to_solvo'
    static GIVE_PASS = 'give_pass'
    static GIVE_PASS_PERIOD = 'give_pass_period'
    static GIVE_PASS_ONE = 'give_pass_one'
    static GIVE_PASS_PERMANENT = 'give_pass_permanent'
    static QR_SCUD = 'qr_scud'
}
